import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService, GenesisUnitOfWork } from 'app/core/core.module';
import { SharedModule } from 'app/shared/shared.module';
import { DxDataGridComponent } from 'devextreme-angular';
import moment from 'moment';

@Component({
    selector: 'app-inventory-by-date',
    templateUrl: './inventory-by-date.component.html',
    styleUrls: ['./inventory-by-date.component.scss'],
    standalone: false
})
export class InventoryByDateComponent implements OnInit {
    inventory: any[] = [];
    processing = false;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
    onExporting = SharedModule.onExporting;

    constructor(private uow: GenesisUnitOfWork, public auth: AuthService) {}

    async ngOnInit() {
        await this.getData();
    }
    async getData() {
        const inventoryChanges = await this.uow.getInventoryByDateOverview() as any[];
        inventoryChanges.forEach(row => {
            row.builtDate = moment(row.built).toDate();
        });
        this.inventory = inventoryChanges;
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            }
        );
    }
}
